'use strict';

var _ = require('lodash');
var FlightKpiRibbonAggregationService = function FlightKpiRibbonAggregationService() {
  function getSumWeightsKey(productKey, secondFactorName, thirdFactorName) {
    var sumKey;
    if (thirdFactorName) {
      sumKey = secondFactorName + 'Times' + thirdFactorName + 'For' + productKey;
    } else {
      sumKey = secondFactorName + 'For' + productKey;
    }
    return sumKey.toLowerCase();
  }
  function getAverageDefinitionWeightsKey(averageDef) {
    var sumOfWeightsKey = averageDef.sumOfWeights + 'For' + averageDef.sumOfProducts;
    return sumOfWeightsKey.toLowerCase();
  }
  function aggregate(data, aggregations, aggregationConfig) {
    var key;
    var sumOfWeightsAggregations = {};
    var sumOfWeightsAggregationsWithoutDroppedFlights = {};
    var aggregationsWithoutDroppedFlights = _.clone(aggregations);

    // products aggregations to compute
    // result is firstFactor * secondFactor [* thirdFactor]
    var products = aggregationConfig.products;

    // weighted averages to compute
    // result is sumOfProducts / sumOfWeights
    var weightedAverages = aggregationConfig.weightedAverages;
    var aggregationKeys = Object.keys(aggregations);
    var productKeys = Object.keys(products);
    var averageKeys = Object.keys(weightedAverages);
    var aggregatedValue, value, productDef;
    function countSumOfWeights(value, secondFactorName, thirdFactorName, secondFactor, thirdFactor, productKey, withoutDroppedFlights) {
      var sumOfWeights = withoutDroppedFlights ? sumOfWeightsAggregationsWithoutDroppedFlights : sumOfWeightsAggregations;
      if (!_.isUndefined(value)) {
        var sumKey;
        if (_.isNumber(secondFactor) && _.isNumber(thirdFactor)) {
          sumKey = getSumWeightsKey(productKey, secondFactorName, thirdFactorName);
          sumOfWeights[sumKey] = (sumOfWeights[sumKey] || 0) + secondFactor * thirdFactor;
        } else if (_.isNumber(secondFactor)) {
          sumKey = getSumWeightsKey(productKey, secondFactorName);
          sumOfWeights[sumKey] = (sumOfWeights[sumKey] || 0) + secondFactor;
        }
      }
    }
    for (var dataIndex = 0, dataLength = data.length; dataIndex < dataLength; dataIndex++) {
      var element = data[dataIndex];

      // first aggregate properties that don't participate in weighted averages count (bookings and revenue)
      var aggregationKeysLength = aggregationKeys.length;
      for (var keyIndex = 0; keyIndex < aggregationKeysLength; keyIndex++) {
        key = aggregationKeys[keyIndex];
        value = element[key];
        if (!_.isUndefined(value)) {
          aggregations[key] = (aggregations[key] || 0) + value;
        }
        if (!element.isLastYearData && !_.isUndefined(value)) {
          aggregationsWithoutDroppedFlights[key] = (aggregationsWithoutDroppedFlights[key] || 0) + value;
        }
      }
      keyIndex = 0;
      // secondly count sum of products and sum of weights - they will be used to count weighted averages later
      for (var productKeysLength = productKeys.length; keyIndex < productKeysLength; keyIndex++) {
        value = undefined;
        key = productKeys[keyIndex];
        productDef = products[key];
        aggregatedValue = aggregations[key];
        var firstFactor = element[productDef.firstFactor];
        var secondFactor = element[productDef.secondFactor];
        if (_.isNumber(firstFactor) && _.isNumber(secondFactor)) {
          value = firstFactor * secondFactor;
        }

        // if third factor is defined then we multiply value by third factor value
        var thirdFactor = element[productDef.thirdFactor];
        if (_.isNumber(value) && _.isNumber(thirdFactor)) {
          value = value * thirdFactor;
        }
        if (!_.isUndefined(value)) {
          aggregations[key] = (aggregatedValue || 0) + value;
          countSumOfWeights(value, productDef.secondFactor, productDef.thirdFactor, secondFactor, thirdFactor, key);
        }
        if (!element.isLastYearData && !_.isUndefined(value)) {
          aggregationsWithoutDroppedFlights[key] = (aggregationsWithoutDroppedFlights[key] || 0) + value;
          countSumOfWeights(value, productDef.secondFactor, productDef.thirdFactor, secondFactor, thirdFactor, key, true);
        }
      }
    }

    // lastly count weighted averages
    for (var index = 0, averageKeysLength = averageKeys.length; index < averageKeysLength; index++) {
      key = averageKeys[index];
      var averageDef = weightedAverages[key];
      var sumOfProducts, sumOfWeights;
      var sumOfWeightsKey = getAverageDefinitionWeightsKey(averageDef);
      if (averageDef.includeDroppedFlights) {
        sumOfProducts = aggregations[averageDef.sumOfProducts];
        sumOfWeights = sumOfWeightsAggregations[sumOfWeightsKey];
      } else {
        sumOfProducts = aggregationsWithoutDroppedFlights[averageDef.sumOfProducts];
        sumOfWeights = sumOfWeightsAggregationsWithoutDroppedFlights[sumOfWeightsKey];
      }
      if (_.isNumber(sumOfProducts) && _.isNumber(sumOfWeights) && sumOfWeights !== 0) {
        aggregations[key] = sumOfProducts / sumOfWeights;
      } else {
        aggregations[key] = NaN;
      }
    }
    return aggregations;
  }
  return {
    aggregate: aggregate
  };
};
FlightKpiRibbonAggregationService.$inject = ['FeatureToggleService'];
module.exports = FlightKpiRibbonAggregationService;